import React, { useState, useEffect } from 'react';

interface DealTypeCard {
  id: string;
  title: string;
  description: string;
  gradient: string;
  badgeColor: string;
}

const dealTypeCards: DealTypeCard[] = [
  {
    id: 'legends',
    title: 'LEGENDS',
    description: 'Deals with 30+ successful payouts and consistent on-time repayments.',
    gradient: 'linear-gradient(98.3deg, #2C997A 6.62%, #047857 135.64%)',
    badgeColor: '#047857',
  },
  {
    id: 'power',
    title: 'POWER HOUR',
    description: 'Time-limited campaigns featuring only deals with IRR ≥14%.',
    gradient: 'linear-gradient(94.96deg, #0369A1 2.01%, #04527D 132.5%)',
    badgeColor: '#0284C7',
  },
  {
    id: 'deluxe',
    title: 'DELUXE DEAL',
    description: 'Higher minimum investment ~(≥ ₹5L) and IRR ~(≥15%). Listed first if live.',
    gradient: 'linear-gradient(99.06deg, #A25418 4.01%, #4E2404 135.07%)',
    badgeColor: '#B45309',
  },
  {
    id: 'spotlight',
    title: 'SPOT LIGHT',
    description: 'Newly listed deals on the platform (first-time listings only).',
    gradient: 'linear-gradient(96.85deg, #382F9C 6%, #211C64 118.34%)',
    badgeColor: '#4F46E5',
  },
];

const DealExplanationCarousel: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === dealTypeCards.length - 1 ? 0 : prevIndex + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? dealTypeCards.length - 1 : prevIndex - 1));
  };

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  // Auto-rotation every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
    <div className="relative w-full flex flex-col items-center justify-center">
      {/* Carousel Container */}
      <div className="relative overflow-hidden rounded-lg w-full">
        <div
          className="flex transition-transform duration-300 ease-in-out"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {dealTypeCards.map((card) => (
            <div
              key={card.id}
              className="w-full flex-shrink-0 relative border-stone-200 border"
              style={{
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '16px 16px 18px',
                gap: '32px',
                isolation: 'isolate',
                width: '100%',
                minHeight: '105px',
                background: card.gradient,
                borderRadius: '8px',
                flex: 'none',
                order: 0,
                alignSelf: 'stretch',
                flexGrow: 0,
              }}
            >
              {/* Overlay Rectangle */}
              <div
                className="absolute inset-0"
                style={{
                  width: '100%',
                  height: '100%',
                  background: '#D9D9D9',
                  opacity: 0.08,
                  zIndex: 0,
                }}
              />

              {/* Content Container */}
              <div
                className="flex flex-col items-start gap-3 relative z-10 w-full"
                style={{
                  minHeight: '71px',
                }}
              >
                {/* Badge */}
                <div
                  className="flex items-center justify-center"
                  style={{
                    boxSizing: 'border-box',
                    padding: '4px 12px',
                    width: 'fit-content',
                    height: '23px',
                    background: '#FFFFFF',
                    borderRadius: '4px',
                  }}
                >
                  <span
                    className="font-semibold uppercase"
                    style={{
                      fontFamily: 'Inter',
                      fontStyle: 'normal',
                      fontWeight: 600,
                      fontSize: '10px',
                      lineHeight: '150%',
                      textAlign: 'center',
                      letterSpacing: '0.08em',
                      textTransform: 'uppercase',
                      color: card.badgeColor,
                    }}
                  >
                    {card.title}
                  </span>
                </div>

                {/* Description */}
                <p
                  className="text-white w-full"
                  style={{
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '12px',
                    lineHeight: '150%',
                    color: '#FFFFFF',
                  }}
                >
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Navigation Arrows */}
      {/* <button
        onClick={prevSlide}
        className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200"
        aria-label="Previous slide"
      >
        <ChevronLeftIcon className="w-4 h-4" />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200"
        aria-label="Next slide"
      >
        <ChevronRightIcon className="w-4 h-4" />
      </button> */}

      {/* Dots Indicator */}
      <div className="flex justify-center mt-2 space-x-2">
        {dealTypeCards.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2 h-2 rounded-full transition-all duration-200 ${
              index === currentIndex ? 'w-6 bg-green-700' : 'bg-gray-300 hover:bg-gray-400'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default DealExplanationCarousel;
